import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Heart, User } from 'lucide-react';
import { ImageUploader } from '@/components/ImageUploader';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';

interface OnboardingStep2Props {
  spouseName: string;
  spousePhoto?: string;
  onUpdate: (name: string) => void;
  onPhotoUpdate: (photo: string | undefined) => void;
}

export const OnboardingStep2 = ({ spouseName, spousePhoto, onUpdate, onPhotoUpdate }: OnboardingStep2Props) => {
  const [localName, setLocalName] = useState(spouseName);

  const handleChange = (value: string) => {
    setLocalName(value);
    onUpdate(value);
  };

  return (
    <div className="h-full flex flex-col justify-center px-6">
      <div className="max-w-sm mx-auto w-full space-y-8">
        {/* Header avec emoji */}
        <div className="text-center space-y-4">
          <Heart className="h-16 w-16 mx-auto text-red-400" />
          <h2 className="text-3xl font-bold text-foreground">Votre conjoint(e)</h2>
          <p className="text-lg text-muted-foreground">
            Ajoutez le prénom de votre conjoint ou conjointe
          </p>
        </div>

        {/* Contenu centré avec le même design que les enfants */}
        <div className="flex flex-col items-center space-y-6">
          {/* Photo ronde avec icône de profil à l'intérieur */}
          <div className="relative">
            <Avatar className="h-24 w-24 border-2 border-border">
              <AvatarImage src={spousePhoto} alt={`Photo de ${localName || 'votre conjoint(e)'}`} />
              <AvatarFallback className="bg-muted">
                <User className="h-8 w-8 text-muted-foreground" />
              </AvatarFallback>
            </Avatar>
            
            {/* Overlay avec ImageUploader pour changer la photo */}
            <div className="absolute inset-0">
              <ImageUploader
                currentImageUrl={spousePhoto}
                onImageUploaded={onPhotoUpdate}
                bucketPath="person-photos"
                size="lg"
              >
                <div className="h-24 w-24 rounded-full"></div>
              </ImageUploader>
            </div>
          </div>
          
          {/* Input prénom centré */}
          <div className="w-full max-w-xs">
            <input
              id="spouseName"
              value={localName}
              onChange={(e) => handleChange(e.target.value)}
              placeholder="Prénom de votre conjoint(e)"
              className="w-full h-12 px-4 text-lg text-center bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
              autoFocus
            />
          </div>
        </div>
      </div>
    </div>
  );
};